//	Polls on an interval, only while the page is visible, with a random
//	offset so many screens opened at the same moment don't all ask the server
//	in the same second. Coming back to a visible tab refreshes at once.
//	`always` (the event screen) ignores visibility.
export function createRefresher({
	intervalMs = 30_000,
	jitterMs = 5_000,
	tick,
	isVisible = () => document.visibilityState === 'visible',
	always = false,
	random = Math.random,
	setTimer = setTimeout,
	clearTimer = clearTimeout,
}) {
	let handle = null;
	let running = false;

	const schedule = () => {
		clearTimer(handle);
		handle = setTimer(fire, intervalMs + Math.floor(random() * jitterMs));
	};
	const fire = async () => {
		if (!running) return;
		if (always || isVisible()) await tick();
		if (running) schedule();
	};

	return {
		start() {
			running = true;
			schedule();
		},
		stop() {
			running = false;
			clearTimer(handle);
		},
		//	Tab became visible again: fetch now, restart the clock.
		async resume() {
			if (!running) return;
			await tick();
			schedule();
		},
		//	Full refresh now (everything), restart the clock.
		async now() {
			await tick();
			if (running) schedule();
		},
		//	The caller fetched what it needed itself: just restart the clock.
		restart() {
			if (running) schedule();
		},
	};
}
